import { render } from "./WizardStepper.vue?vue&type=template&id=517bfc72&scoped=true"
import script from "./WizardStepper.vue?vue&type=script&lang=js"
export * from "./WizardStepper.vue?vue&type=script&lang=js"

import "./WizardStepper.vue?vue&type=style&index=0&id=517bfc72&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517bfc72"]])

export default __exports__